import { Text } from '@chakra-ui/react';
import * as React from 'react';

import { XCircleIcon } from '@/imports/ui/chakra/feather';

export const RejectedModerationState: React.FC = () => {
  return (
    <>
      <XCircleIcon color="red.500" />
      <Text textStyle="compact" as="span" flexGrow="1">
        This post was rejected by an admin
      </Text>
    </>
  );
};
